import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../Application';

import { DevicesView } from '../../ui/views/Devices';

import { fetchDevices, activateDevice, createDevice, updateDevice,deleteDevice, deleteAssignment } from '../../connectors/Devices/actions';
import toast from "../../utils/ToasterService";
import {whiteLabelData} from "../../ui/theme"

import {apiClient} from "../../services/api";
import log from 'loglevel'
import { t } from 'i18next';

var pageTitle = ""
const title = whiteLabelData.name

const mapStateToProps = state => ({
  title: state.application.title,
  activeDeviceId: state.devices.active,
  devices: state.devices.map,
  accessToken: state.authentication.accessToken,
  currentUser: state.users.currentUser,
  currentDevice: (state.devices.map[state.devices.active] || { setupData: {} }),
  currentDeviceId: (state.devices.map[state.devices.active] || { settings: {} }).deviceid,
});

const mapDispatchToProps = dispatch => ({
  fetchDevices: accessToken => dispatch(fetchDevices(accessToken)),
  activateDevice: id => dispatch(activateDevice(id)),
  createDevice: (device, successCB,errorCb) => dispatch(createDevice(device,successCB,errorCb)),
  deleteDevice: (id, successCB) => dispatch(deleteDevice(id,successCB)),
  deleteAssignment: (id, successCB) => dispatch(deleteAssignment(id,successCB)),
  updateDevice: (accessToken, id, label) => dispatch(updateDevice(accessToken, id, label)),
});

/**
 * Devices
 */
class Devices extends PureComponent {
  static propTypes = {
    activeDeviceId: PropTypes.string,
    devices: PropTypes.shape({}),
    fetchDevices: PropTypes.func.isRequired,
    activateDevice: PropTypes.func.isRequired,
    createDevice: PropTypes.func.isRequired,
    updateDevice: PropTypes.func.isRequired,
  }

  static defaultProps = {
    activeDeviceId: undefined,
    devices: {},
  }

  componentWillMount() {
    // this.props.fetchDevices(this.props.accessToken);
    pageTitle = t('PageTitles.devices')
    this.secondLoad()
  }

  secondLoad = () => {

    var data = { deviceid: this.props.currentDeviceId }
    log.debug("SECONDLOAD", data)
    apiClient.post('control/settings/store', data)
      .then(res => {
        if (res.status === 200) {
          log.debug("STATE UPDATE CMD OK")
          this.props.fetchDevices(this.props.accessToken)
        }
      })
      .then(()=> {
        setTimeout(() =>{
          this.props.fetchDevices()
            log.debug("2 Seconds LATER")

      }, 2000)
      })
  }

  handleCreateDevice = (device) => {

    
    let _this = this;
    return new Promise(function(resolve, reject) {

      _this.props.createDevice(device, (success) => {
        _this.props.fetchDevices();
        resolve();
      }, (error) => {
        reject(error);
      });

    })
  }

  onDeleteDevice = (id) => {
    console.log("Deleting''''''''''''##############")
      log.debug("DELETE DEVICE",id)
        this.props.deleteDevice({deviceId: id}, (success) => {
            this.props.fetchDevices();
        });
    }

    onDeleteAssignment = (deviceid, userid, cb) => {
        log.debug("DELETE USER",deviceid, userid)
        this.props.deleteAssignment({deviceId: deviceid, userId: userid}, (success) => {
            toast.success("Benutzer erfolgreich entfernt." );
            this.props.fetchDevices(() => {
                if(cb) cb();
            });

        });
    }

  handleUpdateDevice = (id, label) => {
    this.props.updateDevice(this.props.accessToken, id, label);
  }

  render () {
    log.debug("VIEWCONTROLLER")
    if (this.props.currentDevice.state === undefined) {
      return (
        <DevicesView
          title= {pageTitle}
          devices={this.props.devices}
          activeDeviceId={this.props.activeDeviceId}
          onActivateDevice={this.props.activateDevice}
          onCreateDevice={this.handleCreateDevice}
          onUpdateDevice={this.handleUpdateDevice}
          onDeleteDevice={this.onDeleteDevice}
          onDeleteAssignment={this.onDeleteAssignment}
          currentUser={this.props.currentUser}
          onMyload={this.secondLoad}
        />
      );
    } else {
      return (
        <DevicesView
          title= {pageTitle}
          devices={this.props.devices}
          activeDeviceId={this.props.activeDeviceId}
          onActivateDevice={this.props.activateDevice}
          onCreateDevice={this.handleCreateDevice}
          onUpdateDevice={this.handleUpdateDevice}
          onDeleteDevice={this.onDeleteDevice}
          onDeleteAssignment={this.onDeleteAssignment}
          currentUser={this.props.currentUser}
          onMyload={this.secondLoad}
          deviceVarList={this.props.currentDevice.state.varlist}
          gateWayData={this.props.currentDevice.state.gateway}
          currentDeviceID={this.props.currentDevice.deviceid}
        />
      );
    }
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Devices)), title);
